const ManageNewsCurrent = "MANAGENEWS/CURRENT";
const ManageNewsLanguage = "MANAGENEWS/LANGUAGE";
const ManageNewsType = "MANAGENEWS/TYPE";
const ManageNewsTitle = "MANAGENEWS/TITLE";

// 默认数据
const defaultState = {
  current: 1, // 分页器 - 当前页码
  language: "CN", // 筛选新闻语言
  type: "all", // 筛选新闻类别
  title: "",
};

export default function Reducer(state = defaultState, action) {
  switch (action.type) {
    case ManageNewsCurrent:
      return {
        ...state,
        current: action.payload
      };
    case ManageNewsLanguage:
      return {
        ...state,
        language: action.payload
      };
    case ManageNewsType:
      return {
        ...state,
        type: action.payload
      };
    case ManageNewsTitle:
      return {
        ...state,
        title: action.payload
      };
    default:
      return state;
  }
}

/*
 * 设置当前页码
 */
export const createChangePageNoAction = current => dispatch => {
  dispatch({
    type: ManageNewsCurrent,
    payload: current
  });
};
// 设置当前筛选的语言类型
export const createChangeLanguageAction = current => dispatch => {
  dispatch({
    type: ManageNewsLanguage,
    payload: current
  });
};

// 设置当前筛选类别
export const createChangeTypeAction = current => dispatch => {
  dispatch({
    type: ManageNewsType,
    payload: current
  });
};

export const createChangeTitleAction = current => dispatch => {
  dispatch({
    type: ManageNewsTitle,
    payload: current
  });
};



// WEBPACK FOOTER //
// ./src/redux/ManageNews.jsx